import {FontAwesomeButtonEnumTypes} from "../../../components/cards/FontAwesomeButtonEnumTypes";

export class SC_ImageStatuses {
    static readonly NONE = -1;
    static readonly ANY = 0;
    static readonly MISSING = 1;
    static readonly REQUIRES_REVIEW = 2;
    static readonly REQUIRES_UPLOAD = 3;
    static readonly COMPLETE = 4;
    static readonly COMPLETELY_COMPLETED = 5;

    constructor(private flagReport: number = SC_ImageStatuses.ANY) { }

    static fromAPI(apiValue: number): SC_ImageStatuses {
        switch (apiValue) {
            case SC_ImageStatuses.NONE:
                return new SC_ImageStatuses(SC_ImageStatuses.NONE);
            case SC_ImageStatuses.MISSING:
                return new SC_ImageStatuses(SC_ImageStatuses.MISSING);
            case SC_ImageStatuses.REQUIRES_REVIEW:
                return new SC_ImageStatuses(SC_ImageStatuses.REQUIRES_REVIEW);
            case SC_ImageStatuses.REQUIRES_UPLOAD:
                return new SC_ImageStatuses(SC_ImageStatuses.REQUIRES_UPLOAD);
            case SC_ImageStatuses.COMPLETE:
                return new SC_ImageStatuses(SC_ImageStatuses.COMPLETE);
            case SC_ImageStatuses.COMPLETELY_COMPLETED:
                return new SC_ImageStatuses(SC_ImageStatuses.COMPLETELY_COMPLETED);
            default:
                return new SC_ImageStatuses();
        }
    }

    is(type: number): boolean {
        return this.flagReport === type;
    }

    toAPI(): number {
        return this.flagReport;
    }

    clone(): SC_ImageStatuses {
        return new SC_ImageStatuses(this.flagReport);
    }

    static readonly imageStatuses = [
        { key: SC_ImageStatuses.ANY, display: "Any" },
        { key: SC_ImageStatuses.MISSING, display: "Missing" },
        { key: SC_ImageStatuses.REQUIRES_REVIEW, display: "Review Needed" },
        { key: SC_ImageStatuses.REQUIRES_UPLOAD, display: "Upload Needed" },
        { key: SC_ImageStatuses.COMPLETELY_COMPLETED, display: "Ready to Invoice" },
    ];

    get buttonType(): FontAwesomeButtonEnumTypes {
        switch (this.flagReport) {
            case SC_ImageStatuses.NONE:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_RED
                });
            case SC_ImageStatuses.MISSING:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_ORANGE
                });
            case SC_ImageStatuses.REQUIRES_REVIEW:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_YELLOW
                });
            case SC_ImageStatuses.REQUIRES_UPLOAD:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_GREEN
                });
            case SC_ImageStatuses.COMPLETE:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_BLUE
                });
            case SC_ImageStatuses.COMPLETELY_COMPLETED:
                return new FontAwesomeButtonEnumTypes({
                    mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_DEEP_BLUE
                });
        }
        return new FontAwesomeButtonEnumTypes({
            mainColor: FontAwesomeButtonEnumTypes.MAINS_COLOR_DEEP_BLUE,
            borderColor: FontAwesomeButtonEnumTypes.BORDER_COLOR_RED
        });
    }
}
